var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 2.66669C8.64008 2.66669 2.66675 8.64002 2.66675 16C2.66675 23.36 8.64008 29.3334 16.0001 29.3334C23.3601 29.3334 29.3334 23.36 29.3334 16C29.3334 8.64002 23.3601 2.66669 16.0001 2.66669ZM16.0001 6.66669C18.2134 6.66669 20.0001 8.45335 20.0001 10.6667C20.0001 12.88 18.2134 14.6667 16.0001 14.6667C13.7867 14.6667 12.0001 12.88 12.0001 10.6667C12.0001 8.45335 13.7867 6.66669 16.0001 6.66669ZM8.00008 21.3067C9.72008 23.8934 12.6667 25.6 16.0001 25.6C19.3334 25.6 22.2801 23.8934 24.0001 21.3067C23.9601 18.6534 18.6534 17.2 16.0001 17.2C13.3334 17.2 8.04008 18.6534 8.00008 21.3067Z",
    fill: "#27465B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f2c09d69eb8264f696b78597521c28eb.svg";
export { ForwardRef as ReactComponent };